import {Action} from '@ngrx/store';
import {
    Funktionsbereich,
    FunktionsbereichAdminBenutzer, FunktionsbereichDetail,
    FunktionsbereichFreigabeRolle,
    Rolle
} from '../../../clients/benutzerverwaltung';
import {MitteilungsVorlage} from '../../../clients/kommunikation';

export const PAGE_STATE_RESET = '[FunktionsbereicheRollenPage] Page State reset';

// UI
export const NEUEN_FUNKTIONSBEREICH = '[FunktionsbereicheRollenPage] Neuen Funktionsbereich (Felder leeren)';
export const NEUEN_FUNKTIONSBEREICH_ABBRECHEN = '[FunktionsbereicheRollenPage] Neuen Funktionsbereich abbrechen (Felder leeren)';
export const NEUE_ROLLE = '[FunktionsbereicheRollenPage] Neue Rolle';
export const NEUE_ROLLE_ABBRECHEN = '[FunktionsbereicheRollenPage] Neue Rolle abbrechen';
export const FUNKTIONSBEREICH_SUCHEN = '[FunktionsbereicheRollenPage] Funktionsbereich suchen';

export const AKTUELLEN_FUNKTIONSBEREICH_GESETZT = '[FunktionsbereicheRollenPage] Aktuellen Funktionsbereich gesetzt';
export const AKTUELLE_ROLLE_GESETZT = '[FunktionsbereicheRollenPage] Aktuelle Rolle gesetzt';
export const AKTUELLEN_FUNKTIONSBEREICHS_ADMIN_GESETZT = '[FunktionsbereicheRollenPage] Aktuellen Funktionsbereichs-Admin gesetzt';
export const AKTUELLEN_FUNKTIONSBEREICHS_FREIGABE_ROLLE_GESETZT = '[FunktionsbereicheRollenPage] Aktuellen Funktionsbereichs-Freigabe-Rolle gesetzt';

export const AKTUELLEN_TAB_GESETZT = '[FunktionsbereicheRollenPage] Aktuellen Tab gesetzt';
export const AKTUELLEN_FUNKTIONSBEREICH_ZWISCHGESPEICHERT = '[FunktionsbereicheRollenPage] Aktuellen Funktionsbereich zwischengespeichert';
export const AKTUELLER_FUNKTIONSBEREICH_WURDE_GELOESCHT = '[FunktionsbereicheRollenPage] Aktuellen Funktionsbereich wurde gelöscht';
export const AKTUELLE_ROLLE_WURDE_GELOESCHT = '[FunktionsbereicheRollenPage] Aktuelle Rolle wurde gelöscht';

export const AKTUELLE_MITTEILUNGS_VORLAGE_GESETZT = '[FunktionsbereicheRollenPage] Aktuelle Mitteilungsvorlage gesetzt';
export const NEUE_MITTEILUNGS_VORLAGE =  '[FunktionsbereicheRollenPage] Neue Mitteilungsvorlage';
export const VORLAGE_TITEL_SETZEN = '[FunktionsbereicheRollenPage] Mitteilungsvorlage Titel setzen';
export const VORLAGE_BESCHREIBUNG_SETZEN = '[FunktionsbereicheRollenPage] Mitteilungsvorlage Beschreibung setzen';
export const MITTEILUNGS_VORLAGE_SPEICHERN = '[FunktionsbereicheRollenPage] Mitteilungsvorlage speichern';
export const AKTUELLE_VORLAGE_EMPFAENGER_SETZEN = '[FunktionsbereicheRollenPage] Mitteilungsvorlage aktuelle Empfänger setzen';
export const AKTUELLE_VORLAGE_TYPEN_SETZEN = '[FunktionsbereicheRollenPage] Mitteilungsvorlage aktuelle Typen setzen';

// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;
}

// UI
export class FunktionsbereichSuchenAction implements Action {
    readonly type = FUNKTIONSBEREICH_SUCHEN;

    constructor(public filterString: string) {
    }
}

export class NeuenFunktionsbereichAction implements Action {
    readonly type = NEUEN_FUNKTIONSBEREICH;

    constructor(public funktionsbereichDetail: FunktionsbereichDetail) {
    }
}

export class NeuenFunktionsbereichAbbrechenAction implements Action {
    readonly type = NEUEN_FUNKTIONSBEREICH_ABBRECHEN;

    constructor() {
    }
}

export class NeueRolleAction implements Action {
    readonly type = NEUE_ROLLE;

    constructor() {
    }
}

export class NeueRolleAbbrechenAction implements Action {
    readonly type = NEUE_ROLLE_ABBRECHEN;

    constructor() {
    }
}

export class AktuelleRolleSetzenAction implements Action {
    readonly type = AKTUELLE_ROLLE_GESETZT;

    constructor(public rolle: Rolle) {
    }
}

export class AktuellenFunktionsbereichSetzenAction implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICH_GESETZT;

    constructor(public funktionsbereich: Funktionsbereich) {
    }
}

export class AktuellenFunktionsbereichsAdminSetzenAction implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICHS_ADMIN_GESETZT;

    constructor(public funktionsbereichAdminBenutzer: FunktionsbereichAdminBenutzer) {
    }
}

export class AktuellenFunktionsbereichsFreigabeRolleSetzenAction implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICHS_FREIGABE_ROLLE_GESETZT;

    constructor(public funktionsbereichFreigabeRolle: FunktionsbereichFreigabeRolle) {
    }
}

export class AktuellenTabSetzenAction implements Action {
    readonly type = AKTUELLEN_TAB_GESETZT;

    constructor(public tab: string) {
    }
}

export class AktuellenFunktionsbereichZwischengespeichert implements Action {
    readonly type = AKTUELLEN_FUNKTIONSBEREICH_ZWISCHGESPEICHERT;

    constructor() {
    }
}

export class AktuellerFunktionsbereichWurdeGeloescht implements Action {
    readonly type = AKTUELLER_FUNKTIONSBEREICH_WURDE_GELOESCHT;

    constructor() {
    }
}

export class AktuelleRolleWurdeGeloescht implements Action {
    readonly type = AKTUELLE_ROLLE_WURDE_GELOESCHT;

    constructor() {
    }
}

export class AktuelleMitteilungsVorlageSetzenAction implements Action {
    readonly type = AKTUELLE_MITTEILUNGS_VORLAGE_GESETZT;

    constructor(public payload: MitteilungsVorlage) {
    }
}

export class NeueMitteilungsVorlageAction implements Action {
    readonly type = NEUE_MITTEILUNGS_VORLAGE;

    constructor() {
    }
}

export class VorlageTitelSetzenAction implements Action {
    readonly type = VORLAGE_TITEL_SETZEN;

    constructor(public payload: string) {
    }
}

export class VorlageBeschreibungSetzenAction implements Action {
    readonly type = VORLAGE_BESCHREIBUNG_SETZEN;

    constructor(public payload: string) {
    }
}

export class MitteilungsVorlageSpeichernAction implements Action {
    readonly type = MITTEILUNGS_VORLAGE_SPEICHERN;
    constructor() {
    }
}

export class AktuelleVorlageEmpfaengerSetzenAction implements Action {
    readonly type = AKTUELLE_VORLAGE_EMPFAENGER_SETZEN;
    constructor(public payload: Array<string>) {
    }
}

export class AktuelleVorlageTypenSetzenAction implements Action {
    readonly type = AKTUELLE_VORLAGE_TYPEN_SETZEN;
    constructor(public payload: Array<string>) {
    }
}

export type Actions =
    NeuenFunktionsbereichAction
    | NeuenFunktionsbereichAbbrechenAction
    | NeueRolleAction
    | NeueRolleAbbrechenAction
    | AktuelleRolleSetzenAction
    | AktuellenFunktionsbereichSetzenAction
    | AktuellenFunktionsbereichsAdminSetzenAction
    | AktuellenTabSetzenAction
    | AktuellenFunktionsbereichsFreigabeRolleSetzenAction
    | AktuellenFunktionsbereichZwischengespeichert
    | PageStateResetAction
    | AktuellerFunktionsbereichWurdeGeloescht
    | AktuelleRolleWurdeGeloescht
    | AktuelleMitteilungsVorlageSetzenAction
    | NeueMitteilungsVorlageAction
    | VorlageTitelSetzenAction
    | VorlageBeschreibungSetzenAction
    | MitteilungsVorlageSpeichernAction
    | AktuelleVorlageEmpfaengerSetzenAction
    | AktuelleVorlageTypenSetzenAction
    ;
